import "@/instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Headless PDF export seeds a short-lived token via ?t= on the accounts print route, before React
// mounts, so the auth check on boot can authenticate the one-off render.
try {
  const _p = new URLSearchParams(window.location.search);
  const _t = _p.get("t");
  if (_t && window.location.pathname.includes("/accounts/print")) {
    localStorage.setItem("qube_token", _t);
  }
} catch (_) { /* ignore */ }

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"), {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
